import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaPaperPlane, FaUpload } from "react-icons/fa";
import axios from "axios";
import "./index.scss";
import { showSuccessToaster } from "../../toaster/success";
import { showErrorToaster } from "../../toaster/error";
import { useTranslation } from "react-i18next";

export const ApplyModal = ({ show, handleClose, jobTitle }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    offerId: jobTitle || "",
    cv: null,
  });

  const [loading, setLoading] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({
        ...formData,
        [name]: files[0],
      });
      setSelectedFileName(files[0].name);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const data = new FormData();
      data.append("fullname", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      if (formData.offerId) data.append("offerId", formData.offerId);
      data.append("cv", formData.cv);

      const response = await axios.post(
        "https://api.new-msit-conseil.msit-demo.fr/candidatures",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("✅ Application sent:", response.data);
      showSuccessToaster(t("applyModal.success"));
      handleClose();
      setFormData({
        name: "",
        email: "",
        phone: "",
        offerId: jobTitle || "",
        cv: null,
      });
      setSelectedFileName("");
    } catch (error) {
      console.error("❌ Error:", error);
      showErrorToaster(t("applyModal.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="apply-modal">
      <div className="modal-header-custom">
        <FaPaperPlane className="header-icon" />
        <h5 className="modal-title">{t("applyModal.title")}</h5>
        <button className="close-btn" onClick={handleClose}>
          ✕
        </button>
      </div>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>{t("applyModal.fullName")}*</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={t("applyModal.fullNamePlaceholder")}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("applyModal.email")}*</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="example@yourmail.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("applyModal.phone")}*</Form.Label>
            <Form.Control
              type="tel"
              name="phone"
              placeholder="+33 (555) 123-4567"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>{t("applyModal.cv")}*</Form.Label>
            <div className="cv-upload position-relative">
              <Form.Control
                type="file"
                name="cv"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                required
              />
              <FaUpload className="upload-icon" />
              {selectedFileName && (
                <small className="file-name text-muted mt-1 d-block">
                  📎 {selectedFileName}
                </small>
              )}
            </div>
          </Form.Group>

          <Button type="submit" className="submit-btn w-100" disabled={loading}>
            <FaPaperPlane className="me-2" />
            {loading ? t("applyModal.sending") : t("applyModal.send")}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
